import type { AuthProvider } from "@refinedev/core";

/**
 * Session lives in an HttpOnly cookie set by the backend, so there is nothing to store here and
 * nothing for scripts to leak. `check` asks the server rather than trusting local state.
 */
export const authProvider: AuthProvider = {
  login: async ({ password }: { password: string }) => {
    const response = await fetch("/api/auth/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ password }),
    });

    if (response.ok) {
      return { success: true, redirectTo: "/" };
    }

    return {
      success: false,
      error: {
        name: "LoginError",
        message:
          response.status === 429
            ? "Слишком много попыток. Попробуйте через минуту."
            : response.status === 503
              ? "Пароль администратора не задан на сервере (ADMIN_PASSWORD)."
              : "Неверный пароль",
      },
    };
  },

  logout: async () => {
    await fetch("/api/auth/logout", { method: "POST" });
    return { success: true, redirectTo: "/login" };
  },

  check: async () => {
    try {
      const response = await fetch("/api/auth/me");
      const body = (await response.json()) as { isAuthenticated: boolean };

      return body.isAuthenticated
        ? { authenticated: true }
        : { authenticated: false, redirectTo: "/login" };
    } catch {
      return { authenticated: false, redirectTo: "/login" };
    }
  },

  // The cookie can expire while the tab is open; a 401 from any call sends the user back to login.
  onError: async (error) => {
    if (error?.statusCode === 401 || error?.status === 401) {
      return { logout: true, redirectTo: "/login", error };
    }
    return {};
  },

  getIdentity: async () => ({ name: "Администратор" }),
};
